/* tslint:disable */
/* eslint-disable */
/**
 * VerCasa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthLoginRequest,
  AuthRefreshRequest,
  AuthTokensResponse,
  ErrorResponse,
} from '../models/index';
import {
    AuthLoginRequestFromJSON,
    AuthLoginRequestToJSON,
    AuthRefreshRequestFromJSON,
    AuthRefreshRequestToJSON,
    AuthTokensResponseFromJSON,
    AuthTokensResponseToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/index';

export interface AuthLoginOperationRequest {
    authLoginRequest: AuthLoginRequest;
}

export interface AuthRefreshOperationRequest {
    authRefreshRequest: AuthRefreshRequest;
}

/**
 * 
 */
export class AuthApi extends runtime.BaseAPI {

    /**
     * Logs user into the system
     * Logs user into the system
     */
    async authLoginRaw(requestParameters: AuthLoginOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthTokensResponse>> {
        if (requestParameters['authLoginRequest'] == null) {
            throw new runtime.RequiredError(
                'authLoginRequest',
                'Required parameter "authLoginRequest" was null or undefined when calling authLogin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuthLoginRequestToJSON(requestParameters['authLoginRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthTokensResponseFromJSON(jsonValue));
    }

    /**
     * Logs user into the system
     * Logs user into the system
     */
    async authLogin(requestParameters: AuthLoginOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthTokensResponse> {
        const response = await this.authLoginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a new pair of access and refresh tokens
     * Refreshes a users auth
     */
    async authRefreshRaw(requestParameters: AuthRefreshOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthTokensResponse>> {
        if (requestParameters['authRefreshRequest'] == null) {
            throw new runtime.RequiredError(
                'authRefreshRequest',
                'Required parameter "authRefreshRequest" was null or undefined when calling authRefresh().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/refresh`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuthRefreshRequestToJSON(requestParameters['authRefreshRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthTokensResponseFromJSON(jsonValue));
    }

    /**
     * Returns a new pair of access and refresh tokens
     * Refreshes a users auth
     */
    async authRefresh(requestParameters: AuthRefreshOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthTokensResponse> {
        const response = await this.authRefreshRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
